import { ImageProps } from 'next/image'

export const getImagePath = <T extends ImageProps['src']>(src: T, unoptimized = false): T =>
  process.env.HUB_API_HOST && typeof src === 'string' && src.startsWith('/-/') && !unoptimized
    ? (`${process.env.HUB_API_HOST}${src}` as T)
    : src

